import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import Alert from 'react-bootstrap/Alert'

import { clearNotifications } from '../state/actions/notificationActions'

import { notificationsSignal } from '../state/signals/notificationSignals'

const handleClose = (index) => {
    const filtered = notificationsSignal.value.filter((t, i) => index != i)
    notificationsSignal.value = filtered
}

function ToastItems() {
    let items = notificationsSignal.value.map((t, index) => {

        return (
            <Alert key={index} variant={t.type} onClose={() => handleClose(index)} dismissible className="my-2">
                <Alert.Heading>{t.headerMessage}</Alert.Heading>
                <p>{t.message}</p>
            </Alert>
        )
    })
    return items
}

export default function Notification() {

    const location = useLocation()
    useEffect(() => {
        clearNotifications()
    }, [location])

    if (notificationsSignal.value.length > 0) {
        return (
            <div>
                <ToastItems />
            </div>
        )
    }
}